import { ActionBarContext } from "@bb-vendure/admin-ui/core";
import { ReviewPackageProductDocument } from "src/generated-gql/graphql";
import { take } from "rxjs";

export function reviewPackagesProduct(context: ActionBarContext) {
  const productId = context.route.snapshot.params.id;

  context.dataService
    .mutate(ReviewPackageProductDocument, {
      id: productId,
    })
    .pipe(take(1))
    .subscribe((res) => {
      context.notificationService.success(
        `Create/update ${res.createPackageReviewFromProduct} package reviews successfully`
      );
    });
}